import {createAction, props} from '@ngrx/store';
import {UUID} from '../../../shared/types/uuid.type';

const prefix = '[DeleteStreamConfiguration]';

export const deleteStreamConfiguration = createAction(
  `${prefix} Delete Stream Configuration`,
  props<{ id: UUID }>()
);

export const deleteStreamConfigurationSuccess = createAction(
  `${prefix} Delete Stream Configuration Success`,
  props<{ id: UUID }>()
);

export const deleteStreamConfigurationFailure = createAction(
  `${prefix} Delete Stream Configuration Failure`,
  props<{ error: any }>()
);

export const clearDeleteStreamConfigurationState = createAction(
  `${prefix} Clear Delete Stream Configuration State`
);
